import { SupportedTokenName } from "@mezo/sdk"
import { Block, BlockProps } from "@mezo-org/mezo-clay"

import { getCurrencySymbol } from "../utils"

type CurrencySymbolProps = { token: SupportedTokenName } & BlockProps

export default function CurrencySymbol({
  token,
  ...restProps
}: CurrencySymbolProps) {
  return (
    <Block as="span" {...restProps}>
      {getCurrencySymbol(token)}
    </Block>
  )
}
